module.exports = __webpack_public_path__ + "static/flags/PE-47425d16be22a39d9849419307bb69dc.gif";